const normalizeSafeArea = (value?: string | null) => {
    const safeArea = parseInt(value || '0', 10);
    return Number.isFinite(safeArea) && safeArea > 0 ? `${safeArea}px` : '0px';
}

let safeAreaTop = '0px';
let safeAreaBottom = '0px';

const setSafeArea = ({top, bottom}: { top?: string | null, bottom?: string | null }) => {
    if (top !== undefined)
        safeAreaTop = normalizeSafeArea(top);
    if (bottom !== undefined)
        safeAreaBottom = normalizeSafeArea(bottom);
}

const getSafeAreaTop = () => safeAreaTop;
const getSafeAreaBottom = () => safeAreaBottom;

export {
    getSafeAreaBottom,
    getSafeAreaTop,
    setSafeArea,
};
